import {useAppSelector} from "@taskpane/core/store";
import {FormulasMode} from "@taskpane/utils";

export function useDisplayFormulasMode(): FormulasMode {
  const { displayFormulas } = useAppSelector(state => state.main);

  return displayFormulas ? FormulasMode.Formulas : FormulasMode.Amount;
}
